var map = {
	"./config.json": 106,
	"./en/app.json": 163,
	"./en/common.json": 164,
	"./en/errors.json": 165,
	"./fr/app.json": 166,
	"./fr/common.json": 167,
	"./fr/errors.json": 168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 162;